export default __webpack_public_path__ + "static/media/FuelGenerator.256.169b42df.png";